// extracted by mini-css-extract-plugin
module.exports = {"marginContainer":"margin-container-module--margin-container--EsLK4"};